module.exports = __webpack_public_path__ + "ca6a73d1dc8df866387ed34686a63c4e.svg";